import React, { useCallback, useMemo, useState } from 'react'
import { useMenuSearchContext } from './MenuSearchContext'
import { SearchModal } from './SearchModal'
import { SearchIcon } from './SearchIcon'
import { t } from 'src/translations'
import useScrollDirection from 'src/lib/js/hooks/useScrollDirection'
import { ScreenWidth, useIsMobile } from 'shared/js/utils/WindowContext'
import AnimatedSection from 'public/components/default_template/online_ordering/checkout/AnimatedSection'
import { useGlobalNav } from 'public/components/default_template/GlobalNavContext'

const NavSearchWrapper = ({ channelGuid }: { channelGuid?: string | null }) => {
  const { canUseSearch, clearSearchString, setIsSearching } =
    useMenuSearchContext()
  const [searchModalOpen, setSearchModalOpen] = useState(false)
  const { globalNavOpen } = useGlobalNav()
  const { scrollDirection } = useScrollDirection()
  const isMobile = useIsMobile(ScreenWidth.EXTRA_SMALL)

  const showSearch = useMemo(
    () => !isMobile || globalNavOpen || scrollDirection === 'down',
    [isMobile, scrollDirection, globalNavOpen]
  )

  const handleSearchCancel = useCallback(() => {
    clearSearchString()
    setIsSearching(false)
    setSearchModalOpen(false)
  }, [clearSearchString, setIsSearching])

  if (!canUseSearch) {
    return null
  }

  return (
    <div
      className='navSearchWrapper'
      id='menuSearchContainer'
      data-testid='menu-search-container'
    >
      <AnimatedSection expanded={showSearch} className='searchInputWrapper'>
        <SearchModalTrigger onClick={() => setSearchModalOpen(true)} />
      </AnimatedSection>
      <SearchModal
        isOpen={searchModalOpen}
        onClose={handleSearchCancel}
        channelGuid={channelGuid}
      />
    </div>
  )
}

// A button styled to look like a search input
const SearchModalTrigger = ({ onClick }: { onClick: () => void }) => {
  return (
    <button type='button' className='ooSearch' onClick={onClick}>
      <div className='searchIcon' aria-hidden={true}>
        <SearchIcon />
      </div>
      <span>{t('search-input.placeholder.search')}</span>
    </button>
  )
}

export default NavSearchWrapper
